import script from "./PendenciesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PendenciesTable.vue?vue&type=script&setup=true&lang=js"

import "./PendenciesTable.vue?vue&type=style&index=0&id=572e759c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572e759c"]])

export default __exports__